export const productMapper = {
  mapProduct(product) {
    const mappedProduct = {
      ...product
    };
    if (mappedProduct.data) {
      mappedProduct.data.allergens = mappedProduct.data.allergens
        ? mappedProduct.data.allergens
        : [];
      mappedProduct.data.tags = mappedProduct.data.tags
        ? mappedProduct.data.tags
        : [];
      mappedProduct.data.quantity_inventory = Number(
        product.data.quantity_inventory
      );
      mappedProduct.data.quantity_production =
        product.data.quantity_production !== null
          ? Number(product.data.quantity_production)
          : null;
      mappedProduct.data.prix = product.data.prix
        ? Number(product.data.prix)
        : null;
      mappedProduct.data.prix_inventory = Number(product.data.prix_inventory);
      mappedProduct.data.quantity_order =
        product.data.quantity_order !== null
          ? Number(product.data.quantity_order)
          : null;
      mappedProduct.data.quantity_inventory_order =
        product.data.quantity_inventory_order !== null
          ? Number(product.data.quantity_inventory_order)
          : null;
      mappedProduct.data.price_order =
        product.data.price_order !== null
          ? Number(product.data.price_order)
          : null;
      mappedProduct.data.alternative_price =
        product.data.alternative_price !== null
          ? Number(product.data.alternative_price)
          : null;
      mappedProduct.data.alternative_quantity_inventory = Number(
        product.data.alternative_quantity_inventory
      );
      mappedProduct.data.alternative_quantity_production =
        product.data.alternative_quantity_production !== null
          ? Number(product.data.alternative_quantity_production)
          : null;
    }
    return mappedProduct;
  }
};
